import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #ffffff;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 22px;
  margin-top: 16px;
`;

export const SectionTitle = styled.h4`
  font-weight: 700;
  font-size: 18px;
  color: #212529;
  margin-bottom: 16px;
`;

export const Card = styled.div`
  background: #faf5ff;
  border: 1px solid #e9d4ff;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 10px;
  cursor: pointer;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
`;

export const CardTitle = styled.p`
  font-weight: 600;
  font-size: 13px;
  color: #314158;
`;

export const StatusBadge = styled.span`
  padding: 2px 8px;
  border-radius: 16px;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
  background-color: ${({ status }) =>
    status === 'Completed' ? '#d0fae5' : status === 'Cancelled' ? '#fee2e2' : '#dbeafe'};
  color: ${({ status }) =>
    status === 'Completed' ? '#15c7a7' : status === 'Cancelled' ? '#ef4444' : '#2d6cdf'};
`;

export const Row = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
  align-items: center;
`;

export const Label = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #212529;
`;

export const Value = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #6c757d;
  word-break: break-all;
`;

export const AssigneeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
`;

export const AssigneeBadge = styled.span`
  background: #eff6ff;
  border: 1px solid #bedbff;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 11px;
  color: #314158;
`;

export const EmptyText = styled.p`
  font-size: 13px;
  color: #90a1b9;
  text-align: center;
  padding: 12px 0;
`;

export const LoadingText = styled.p`
  font-size: 13px;
  color: #90a1b9;
  text-align: center;
  padding: 12px 0;
`;
